"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ocSDKConfiguration = {
    getChatTokenRetryCount: 5,
    getChatTokenTimeBetweenRetriesOnFailure: 2000,
    getChatTokenRetryOn429: true,
    useUnauthReconnectIdSigQueryParam: false
};
exports.default = ocSDKConfiguration;
//# sourceMappingURL=ocSDKConfiguration.js.map